App.filter('isUnder16FromBirthdate', function () {
    return function (date) {
        date = date || '';
        if (date) {
            	var date = new Date(date);
        	var preciseMiliseconds = new Date(date.getFullYear() + 16, date.getMonth(), date.getDate()).getTime();
        	var nowMiliseconds = new Date().getTime();

        	if (preciseMiliseconds > nowMiliseconds) {
        		return true;
        	} else {
        		return false;
        	}

        } else {
        	return false;
        }
        return false;
    };
})